/** Resets only the specified form fields to their default values, in a single batched update. */
export const resetFormFields = ({ defaultValues, fieldNames, getValues, reset, }) => {
    const valuesToReset = {};
    fieldNames.forEach((fieldName) => {
        valuesToReset[fieldName] = defaultValues[fieldName];
    });
    reset({ ...getValues(), ...valuesToReset }, {
        keepErrors: false,
        keepDirty: false,
        keepTouched: false,
        keepDefaultValues: true,
        // Without `keepIsSubmitted` the form falls back to the `onSubmit` mode, so a field the user keeps typing in is
        // never revalidated and an error raised before this reset stays on screen forever.
        keepIsSubmitted: true,
    });
};
